import axios from "axios";
import { UrlConstants } from "../../../../utils/ApiConstants";
import { authHeader } from "../../../../utils/utils";
import { Notification } from "../../../../components/notification/notification";
import { replaceWithCurrentApiVersion } from "../../../../utils/api";

export const approveOrRejectRepoCharges: any = (recordId: string, data: any, args: any[]) => {
  const payload = {
    repoKitNo: recordId,
    justification: data["justification"],
    status: args[1]
  };
  return markRepoChargesStatusTo(recordId, args[0], payload, "Successfully marked the status to " + args[1] + ".");
}

export const markRepoChargesStatusTo: any = async (recordId: string, endpoint: string, payload: any, message: string) => {

  endpoint = endpoint?.replace("{recordId}", recordId);
  try {
    let requestBody = JSON.parse(JSON.stringify(payload));

    const { status } = await axios.post(`${UrlConstants.BASE_URL}${replaceWithCurrentApiVersion(endpoint)}`, requestBody, {
      headers: {
        authorization: `${authHeader().Authorization}`,
        "Access-Control-Allow-Origin": "*",
      }
    });
    if (status !== 201) {
      Notification("error", "Transaction failed! ");
      return { message: "Failed to perform the operation: ", status: "ERROR" };
    } else {
      Notification("success", message);
      return { message: message, status: "SUCCESS" };
    }
  } catch (err: any) {
    if (err?.response?.data && err?.response?.data.errorMessages && err?.response?.data.errorMessages.length > 0) {
      const errorMessages = err?.response?.data.errorMessages;
      let error: any = new Error("failed to submit the data");
      error.errorMessages = errorMessages;
      throw error;
    }
    Notification("error", "Something went wrong, please check with admin.");
    return { message: "Something went wrong, please check with admin.", status: "ERROR" };
  }
}

export const markRepoAuctionStatusTo: any = async (recordId: string, endpoint: string, payload: any, message: string) => {

  endpoint = endpoint?.replace("{recordId}", recordId);
  try {
    let requestBody = JSON.parse(JSON.stringify(payload));

    const { status } = await axios.put(`${UrlConstants.BASE_URL}${replaceWithCurrentApiVersion(endpoint)}`, requestBody, {
      headers: {
        authorization: `${authHeader().Authorization}`,
        "Access-Control-Allow-Origin": "*",
      }
    });
    if (status < 200 && status >= 300) {
      Notification("error", "Transaction failed! ");
      return { message: "Failed to perform the operation: ", status: "ERROR" };
    } else {
      Notification("success", message);
      return { message: message, status: "SUCCESS" };
    }
  } catch (err: any) {
    if (err?.response?.data && err?.response?.data.errorMessages && err?.response?.data.errorMessages.length > 0) {
      const errorMessages = err?.response?.data.errorMessages;
      let error: any = new Error("failed to submit the data");
      error.errorMessages = errorMessages;
      throw error;
    }

    Notification("error", "Something went wrong, please check with admin.");
    return { message: "Something went wrong, please check with admin.", status: "ERROR" };
  }
}